import { Link } from "react-router-dom";
import { CalendarDays, Clock, MapPin } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { fmtDate, fmtTime, catLabel } from "@/lib/format";

export const EventCard = ({ e, i = 0 }) => (
  <Link to={`/events/${e.id}`} data-testid={`event-card-${e.id}`} style={{ animationDelay: `${i * 60}ms` }}
    className="card-dark fade-up group block overflow-hidden transition-transform duration-200 active:scale-[0.99]">
    <div className="relative aspect-[16/9] overflow-hidden">
      <img loading="lazy" decoding="async" src={imgUrl(e.image)} alt={e.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#110d09] via-transparent to-transparent" />
      <span className="absolute left-3 top-3 rounded-full border border-[#E6A45D]/50 bg-[#090806]/70 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-[#F6D7A1] backdrop-blur">{catLabel(e.category)}</span>
      {e.remaining <= 0 && <span className="absolute right-3 top-3 rounded-full bg-[#090806]/80 px-3 py-1 text-[10px] font-semibold uppercase text-[#F7F4EE]">Complet</span>}
    </div>
    <div className="flex items-end justify-between gap-3 p-4 pt-2">
      <div className="min-w-0">
        <h3 className="truncate text-base font-semibold text-[#F7F4EE]">{e.title}</h3>
        <div className="mt-2 space-y-1 text-xs text-[#F7F4EE]/70">
          <p className="flex items-center gap-2 capitalize"><CalendarDays size={13} className="text-[#E6A45D]" />{fmtDate(e.starts_at)}</p>
          <p className="flex items-center gap-2"><Clock size={13} className="text-[#E6A45D]" />{fmtTime(e.starts_at)}<MapPin size={13} className="ml-2 text-[#E6A45D]" />{e.city}</p>
        </div>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-2">
        <span className="btn-gold h-9 px-4 text-[11px]">Réserver</span>
      </div>
    </div>
  </Link>
);
